<template>
  <div>
    <div class="header">
      <img class="go_back" src="@/assets/return_btn.png" alt @click="go_back()">
      <h2 class="title">全部专题</h2>
    </div>
    <div class="content">
      <div class="classify">
        <div class="classify_box">
          <div class="classify_item">
            <div class="main_classify">
              专业：
            </div>
            <div class="right_classify">
              <div class="right_item">
                <span v-for="(item,index) in classifyArr" :key="index" class="item" :class="item.id==classifyActive?'active':''" @click="changeClassify(item)">{{ item.category_name }}</span>
              </div>
            </div>
          </div>
          <div class="classify_item">
            <div class="main_classify">
              排序：
            </div>
            <div class="right_classify">
              <div class="right_item">
                <span v-for="(item,index) in sortArr" :key="index" class="item" :class="item.type==sortActive?'active':''" @click="changeSort(item)">{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main_box">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getMoreDatas">
          <div v-for="(item,index ) in list" :key="index" class="topic_item">
            <a @click="goSpecial(item)"><img class="thumb" :src="item.banner" alt=""></a>
            <div class="collect">
              {{ getNum(item.count) }}
              <span class="text">收藏</span>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import { category, getVipSpecial } from '@/api/vipList'
import tool from '@/utils/tools.js'

export default {
  components: {
  },
  data() {
    return {
      page: 1,
      timer: null,
      limit: 10,
      loading: false,
      finished: false,
      classifyArr: [], // 全部专业
      sortArr: [{
        type: 1,
        name: '最新'
      }, {
        type: 2,
        name: '最热'
      }],
      classifyActive: '', // 专业高亮
      sortActive: 1, // 排序高亮
      count: 0,
      list: [],
      query: {
        category_id: '',
        type: 1
      }
    }
  },
  created() {
    this.getCategory()
  },
  mounted() {

  },
  methods: {
    goSpecial(val){
      window.location.href = '/svip/vipSpecial?id='+val.id
    },
    // 获取专业
    getCategory() {
      category().then((res) => {
        if (res.errNo == 0) {
          res.result.unshift({ id: '', category_name: '全部' })
          this.classifyArr = res.result
        }
      })
    },
    getMoreDatas(cur_page) {
      this.onLoad(cur_page)
    },
    onLoad(cur_page) {
      this.loading = true
      this.page = cur_page || this.getCurrentPage()
      console.log('page is ' + this.page)
      const params = {
        page: this.page,
        limit: this.limit,
        ...this.query
      }
      getVipSpecial(params).then(res => {
        this.loading = false
        const result = res.result ? res.result : {}
        const list = result.list ? result.list : []
        this.count = result.count
        if (this.page === 1) {
          this.list = list
        } else {
          this.list = this.list.concat(list)
        }
        // 是否结束
        if (list.length < this.page) {
          this.finished = true
          console.log('没有更多了')
        } else {
          this.finished = false
        }
      })
    },
    // 切换排序
    changeSort(item) {
      // this.page = 1
      this.sortActive = item.type
      this.query.type = item.type
      this.getMoreDatas(1)
    },
    // 切换专业
    changeClassify(item) {
      // this.page = 1
      this.classifyActive = item.id
      this.query.category_id = item.id
      this.getMoreDatas(1)
    },
    getCurrentPage() {
      const count = this.list.length
      const limit = this.limit
      const page = Math.ceil((count / limit)) + 1 // 默认1
      return page
    },
    getNum(num) {
      if (num < 1000) {
        return num
      } else if (num >= 1000 && num < 10000) {
        return parseInt((num / 1000 * 10)) / 10 + 'k'
      } else if (num >= 10000) {
        return parseInt((num / 10000 * 10)) / 10 + 'w'
      }
    },
    // 返回
    go_back() {
      if (tool.isInApp()) {
        if (tool.isInIosApp()) {
          window.webkit.messageHandlers.vue_backApp.postMessage('app')
        } else {
          window.WebViewJavascriptBridge.callHandler(
            'vue_backApp'
            , '支付页返回'
            , function(responseData) {
              // android 返参数接受
            }
          )
        }
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header{
  width: 100%;
  height: 70px;
  position: sticky;
  top: 0;
  background: #000;
  z-index: 1;
  display: flex;
  align-items: center;
  .title{
    height: 70px;
    line-height: 70px;
    margin: 0 auto;
    color:#fff;
  }
}
.go_back{
  width: 36px;
  height: 36px;
  position: absolute;
  left: 38px;
}
.content{
  padding:0 40px 40px;
  background: #23211E;
}
.classify{
    padding:40px 0;
    position:sticky;
    top:70px;
    width: 100%;
    z-index: 1;
    background: #23211E;
    .classify_box{
      margin:0 auto;
      // padding: 43px 0;
      .classify_item{
        display: flex;
        margin-bottom: 20px;
        &:nth-last-child(1){
          margin-bottom:0;
        }
        .main_classify{
          font-family: PingFangSC-Medium;
          font-size: 32px;
          color: #F7D79E;
          letter-spacing: 0;
          font-weight: 500;
          width: 120px;
        }
        .right_classify{
          flex: 1;
          display: flex;
          overflow-x: scroll;
          .right_item{
            flex-shrink:0
          }
        }
        .item{
           display: inline-block;
            font-size: 32px;
            color: #FFFFFF;
            letter-spacing: 0;
            font-weight: 500;
            margin:0 20px 10px;
            // padding:0px 12px;
            // min-width: 72px;
            text-align: center;
            cursor: default;
          }
          .active{
            background-image: linear-gradient(136deg, #F8DAA5 0%, #EBBE6F 100%);
            font-family: PingFangSC-Medium;
            // font-size: 18px;
            color: #956015;
            letter-spacing: 0;
            font-weight: 500;
            padding:0px 12px;
          }
      }
    }
  }
  .main_box{
  // padding: 28px;
  display: flex;
  flex-wrap: wrap;
  // width: 1842px;
  padding-bottom: 1px;
  .topic_item{
    width: 670px;
    height: 285.4px;
    margin-bottom: 40px;
    // margin-bottom: 30px;
    position:relative;
    float: left;
    .thumb{
      width: 100%;
      height: 100%;
    }
    .collect{
      position:absolute;
      bottom:0;
      right: 0;
      background: rgba(51,51,51,0.90);
      border-radius: 12px 0px 0px 0px;
      color:#fff;
      padding: 4px 20px;
      font-size: 24px;
      .text{
        margin-left: 4px;
      }
    }
  }
}
.van-list{
  margin:0 auto;
}
</style>
